import { render, staticRenderFns } from "./SavingsSummaryTable.vue?vue&type=template&id=3ae5cdca&scoped=true&"
import script from "./SavingsSummaryTable.vue?vue&type=script&lang=js&"
export * from "./SavingsSummaryTable.vue?vue&type=script&lang=js&"
import style0 from "./SavingsSummaryTable.vue?vue&type=style&index=0&id=3ae5cdca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae5cdca",
  null
  
)

export default component.exports